import { Col, useTheme, type ViewStyle } from "@rally/ui-kit";

function glow(colour: string, at: ViewStyle, size: number, opacity: number): ViewStyle {
  return {
    position: "absolute",
    width: size,
    height: size,
    borderRadius: size / 2,
    backgroundImage: `radial-gradient(circle at 40% 40%, ${colour}, transparent 64%)`,
    opacity,
    filter: "blur(56px)",
    ...at,
  } as ViewStyle;
}

export function Aura() {
  const theme = useTheme();
  return (
    <Col style={{ position: "absolute", inset: 0, overflow: "hidden", zIndex: -1 } as ViewStyle}>
      <Col style={glow(theme.color.accent, { top: "-20%", left: "-18%" }, 620, 0.22)} />
      <Col style={glow(theme.color.accentStrong, { bottom: "-16%", right: "-12%" }, 520, 0.16)} />
    </Col>
  );
}
